/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/** @format int32 */
export enum SuggestionsViewOptions {
  Value0 = 0,
  Value1 = 1,
}

/** @format int32 */
export enum SuggestionLabels {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
}

/** @format int32 */
export enum SortOrder {
  Value0 = 0,
  Value1 = 1,
}

/** @format int32 */
export enum SelfTapePerformerRequestStatus {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
  Value4 = 4,
  Value5 = 5,
  Value6 = 6,
}

/** @format int32 */
export enum SearchProfileOrderBy {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
  Value4 = 4,
  Value5 = 5,
  Value6 = 6,
  Value7 = 7,
  Value8 = 8,
}

/** @format int32 */
export enum RoleStatus {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
}

/** @format int32 */
export enum ProfilesOptions {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
}

/** @format int32 */
export enum PerformerType {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
  Value4 = 4,
}

/** @format int32 */
export enum OperationType {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
  Value4 = 4,
  Value5 = 5,
  Value6 = 6,
}

/** @format int32 */
export enum MeasurementType {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
  Value4 = 4,
  Value5 = 5,
  Value6 = 6,
  Value7 = 7,
  Value8 = 8,
  Value9 = 9,
  Value10 = 10,
  Value11 = 11,
  Value12 = 12,
  Value13 = 13,
}

/** @format int32 */
export enum LinkmailSuggestionsSearchParametersSortingOptions {
  Value0 = 0,
  Value1 = 1,
}

/** @format int32 */
export enum LinkmailSuggestionsSearchParametersGroupingOptions {
  Value0 = 0,
  Value1 = 1,
}

/** @format int32 */
export enum FilterMode {
  Value0 = 0,
  Value1 = 1,
}

/** @format int32 */
export enum AlertsSortingOptions {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
}

/** @format int32 */
export enum AlertTypes {
  Value0 = 0,
  Value1 = 1,
}

export interface BreakdownFiltersDto {
  repliesTo?: RepliesToFilterDto[] | null;
  roles?: GuidSuggestionsFilterDto[] | null;
  suggestedBy?: Int32SuggestionsFilterDto[] | null;
  labels?: SuggestionLabelsSuggestionsFilterBaseDto[] | null;
  locations?: StringSuggestionsFilterBaseDto[] | null;
  stats?: ProfileSearchStatsDto;
}

export interface FileRelatedEntity {
  fileName?: string | null;
}

export interface GuidSuggestionsFilterDto {
  /** @format uuid */
  id?: string;
  /** @format int32 */
  suggestionsCount?: number;
  description?: string | null;
}

export type IContractResolver = object;

export interface Int32IdentifiableEntity {
  /** @format int32 */
  id?: number;
}

export interface Int32SuggestionsFilterDto {
  /** @format int32 */
  id?: number;
  /** @format int32 */
  suggestionsCount?: number;
  description?: string | null;
}

export interface Int32ValueBucketDto {
  /** @format int32 */
  value?: number;
  /** @format int64 */
  count?: number;
}

export interface Link {
  href?: string | null;
  templated?: boolean | null;
}

export interface MakeSuggestionDtoJsonPatchDocument {
  operations?: MakeSuggestionDtoOperation[] | null;
  contractResolver?: IContractResolver;
}

export interface MakeSuggestionDtoOperation {
  operationType?: OperationType;
  path?: string | null;
  op?: string | null;
  from?: string | null;
  value?: any | null;
}

export interface Measurement {
  measurementType?: MeasurementType;
  /** @format double */
  from?: number | null;
  /** @format double */
  to?: number | null;
}

export interface MeasurementDto {
  measurementType?: MeasurementType;
  /** @format double */
  value?: number;
}

export interface MeasurementDtoValueBucketDto {
  value?: MeasurementDto;
  /** @format int64 */
  count?: number;
}

export interface NewSuggestion {
  /** @format uuid */
  profile?: string | null;
  /** @deprecated */
  artist?: string | null;
  /** @format int32 */
  agencyId?: number;
  /** @format int32 */
  publication?: number;
  /** @maxLength 1000 */
  comment?: string | null;
  /**
   * @format uuid
   * @default "00000000-0000-0000-0000-000000000000"
   */
  photo?: string;
  /**
   * @format uuid
   * @default "00000000-0000-0000-0000-000000000000"
   */
  cdUserId?: string;
}

export interface NudgeDto {
  /** @format int64 */
  id?: number;
  agency?: string | null;
  /** @format date-time */
  dateCreated?: string;
}

export interface Operation {
  operationType?: OperationType;
  path?: string | null;
  op?: string | null;
  from?: string | null;
  value?: any | null;
}

export interface PerformerRelatedEntity {
  artistRef?: string | null;
  forenames?: string | null;
  surname?: string | null;
}

export interface ProfileSearchStatsDto {
  /** @format int32 */
  playingAgeFromMin?: number | null;
  /** @format int32 */
  playingAgeFromMax?: number | null;
  /** @format int32 */
  playingAgeToMin?: number | null;
  /** @format int32 */
  playingAgeToMax?: number | null;
  /** @format int32 */
  performersWithAudioClipsCount?: number | null;
  /** @format int32 */
  performersWithShowReelsCount?: number | null;
  publicationCodes?: Int32ValueBucketDto[] | null;
  performerTypes?: StringValueBucketDto[] | null;
  locations?: StringValueBucketDto[] | null;
  measurements?: MeasurementDtoValueBucketDto[] | null;
  gender?: Int32ValueBucketDto[] | null;
  disabilities?: Int32ValueBucketDto[] | null;
  eyeColours?: Int32ValueBucketDto[] | null;
  facialHairs?: Int32ValueBucketDto[] | null;
  hairColours?: Int32ValueBucketDto[] | null;
  hairLength?: Int32ValueBucketDto[] | null;
  appearances?: Int32ValueBucketDto[] | null;
  voiceStyles?: Int32ValueBucketDto[] | null;
  nationalities?: Int32ValueBucketDto[] | null;
  beltNotes?: Int32ValueBucketDto[] | null;
  heritageAndEthnicity?: Int32ValueBucketDto[] | null;
  accentsAndDialects?: SkillBucketDto[] | null;
  vehicleLicences?: SkillBucketDto[] | null;
  languages?: SkillBucketDto[] | null;
  musicAndDance?: SkillBucketDto[] | null;
  otherSkills?: SkillBucketDto[] | null;
  performances?: SkillBucketDto[] | null;
  sports?: SkillBucketDto[] | null;
  presenting?: SkillBucketDto[] | null;
  voiceOver?: SkillBucketDto[] | null;
  credits?: Int32ValueBucketDto[] | null;
  agents?: StringValueBucketDto[] | null;
  /** @format int32 */
  isSelfRepresented?: number | null;
  /** @format int32 */
  isLookingForRepresentation?: number | null;
  dramaSchools?: StringValueBucketDto[] | null;
  audioClips?: Int32ValueBucketDto[] | null;
  showReels?: Int32ValueBucketDto[] | null;
}

export interface ProfileSkillInput {
  /** @format int32 */
  facetId?: number;
  /** @format int32 */
  levelId?: number | null;
}

export interface RepliesToFilterDto {
  /** @format uuid */
  id?: string;
  /** @format int32 */
  suggestionsCount?: number;
  isAmendment?: boolean;
  /** @format int32 */
  amendmentCount?: number;
  /** @format date-time */
  createdDate?: string;
}

export interface RoleSuggestionChangesDto {
  created?: RoleSuggestionDto[] | null;
  edited?: RoleSuggestionDto[] | null;
  deletedIds?: number[] | null;
}

export interface RoleSuggestionDto {
  links?: Record<string, Link> | null;
  /** @format int32 */
  id?: number;
  photo?: FileRelatedEntity;
  /** @format date-time */
  dateCreated?: string;
  performer?: PerformerRelatedEntity;
  agency?: Int32IdentifiableEntity;
  /** @format int32 */
  amendmentCount?: number;
  comment?: string | null;
  suggestedBy?: string | null;
}

export interface SearchBreakdownSuggestionAgency {
  /** @format int32 */
  id?: number;
  title?: string | null;
  email?: string | null;
  webAddress?: string | null;
  phone1?: string | null;
  phone2?: string | null;
  phone3?: string | null;
  addressLine1?: string | null;
  addressLine2?: string | null;
  addressLine3?: string | null;
  addressLine4?: string | null;
  country?: string | null;
  postCode?: string | null;
}

export interface SearchBreakdownSuggestionDto {
  links?: Record<string, Link> | null;
  /** @format int32 */
  id?: number;
  label?: SuggestionLabels;
  castingDirectorComments?: string | null;
  role?: SearchBreakdownSuggestionRole;
  /** @format int32 */
  publicationCode?: number;
  performer?: SearchBreakdownSuggestionPerformer;
  agency?: SearchBreakdownSuggestionAgency;
  /** @format date-time */
  dateSuggested?: string;
  /** @format int32 */
  suggestedByUserId?: number | null;
  /** @format uuid */
  suggestedByPortalId?: string | null;
  /** @format uuid */
  breakdownId?: string;
  suggestionComments?: string | null;
  photo?: SearchBreakdownSuggestionPhoto;
  showPerformerEmail?: boolean;
  selfTapeRequestSent?: boolean;
  performerReplyComments?: string | null;
  /** @format date-time */
  performerReplyTimestamp?: string | null;
  status?: SelfTapePerformerRequestStatus;
  /** @format int32 */
  mediaRequestType?: number | null;
  selfTapeSubmissions?: SearchBreakdownSuggestionSelfTapeSubmissions[] | null;
  hasMultipleSelfTapeRequests?: boolean;
}

export interface SearchBreakdownSuggestionDtoCollectionDto {
  links?: Record<string, Link> | null;
  /** @format int64 */
  total?: number;
  items?: SearchBreakdownSuggestionDto[] | null;
}

export interface SearchBreakdownSuggestionDtoJsonPatchDocument {
  operations?: SearchBreakdownSuggestionDtoOperation[] | null;
  contractResolver?: IContractResolver;
}

export interface SearchBreakdownSuggestionDtoOperation {
  operationType?: OperationType;
  path?: string | null;
  op?: string | null;
  from?: string | null;
  value?: any | null;
}

export interface SearchBreakdownSuggestionPerformer {
  artistRef?: string | null;
  forenames?: string | null;
  surname?: string | null;
  email?: string | null;
  /** @format uuid */
  performerId?: string;
  hasAudioClip?: boolean;
  hasVideoClip?: boolean;
}

export interface SearchBreakdownSuggestionPhoto {
  fileName?: string | null;
}

export interface SearchBreakdownSuggestionRole {
  /** @format uuid */
  nuRoleId?: string;
  title?: string | null;
}

export interface SearchBreakdownSuggestionSelfTapeSubmissions {
  /** @format uuid */
  projectId?: string;
  /** @format uuid */
  selfTapeRequestId?: string;
}

export interface SkillBucketDto {
  /** @format int32 */
  value?: number;
  /** @format int64 */
  count?: number;
  levels?: Int32ValueBucketDto[] | null;
}

export interface StringSuggestionsFilterBaseDto {
  id?: string | null;
  /** @format int32 */
  suggestionsCount?: number;
}

export interface StringValueBucketDto {
  value?: string | null;
  /** @format int64 */
  count?: number;
}

export interface SuggestionLabelsSuggestionsFilterBaseDto {
  id?: SuggestionLabels;
  /** @format int32 */
  suggestionsCount?: number;
}

export interface SuggestionsOperations {
  created?: NewSuggestion[] | null;
  edited?: Record<string, MakeSuggestionDtoJsonPatchDocument> | null;
  deleted?: number[] | null;
}

export interface UpdateAlertsParameters {
  /** @format int32 */
  id?: number;
  alertType?: AlertTypes;
  read?: boolean;
}

export interface WhoamiDto {
  links?: Record<string, Link> | null;
  name?: string | null;
  id?: string | null;
  userRole?: string | null;
}

import type {
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
  HeadersDefaults,
  ResponseType,
} from "axios";
import axios from "axios";

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams
  extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown>
  extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  JsonApi = "application/vnd.api+json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({
    securityWorker,
    secure,
    format,
    ...axiosConfig
  }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({
      ...axiosConfig,
      baseURL: axiosConfig.baseURL || "",
    });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(
    params1: AxiosRequestConfig,
    params2?: AxiosRequestConfig,
  ): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method &&
          this.instance.defaults.headers[
            method.toLowerCase() as keyof HeadersDefaults
          ]) ||
          {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] =
        property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(
          key,
          isFileType ? formItem : this.stringifyFormItem(formItem),
        );
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (
      type === ContentType.FormData &&
      body &&
      body !== null &&
      typeof body === "object"
    ) {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (
      type === ContentType.Text &&
      body &&
      body !== null &&
      typeof body !== "string"
    ) {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title Spotlight Suggestions API
 * @version v1
 */
export class Api<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  nudges = {
    /**
     * No description
     *
     * @tags Nudges
     * @name NudgesCreateNudge
     * @request POST:/nudges/breakdowns/{linkmailId}/roles/{roleId}/{agencyId}
     * @secure
     */
    nudgesCreateNudge: <TResponse = unknown, TError = any>(
      linkmailId: string,
      roleId: string,
      agencyId: number,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/nudges/breakdowns/${linkmailId}/roles/${roleId}/${agencyId}`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Nudges
     * @name NudgesGetNudge
     * @request GET:/nudges/breakdowns/{linkmailId}/roles/{roleId}/nudges
     * @secure
     */
    nudgesGetNudge: <TResponse = NudgeDto, TError = any>(
      linkmailId: string,
      roleId: string,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/nudges/breakdowns/${linkmailId}/roles/${roleId}/nudges`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
  suggestions = {
    /**
     * No description
     *
     * @tags PerformerSuggestions
     * @name PerformerSuggestionsGet
     * @request GET:/suggestions
     * @secure
     */
    performerSuggestionsGet: <TResponse = unknown, TError = any>(
      query?: {
        /** @format int32 */
        Skip?: number;
        /** @format int32 */
        Take?: number;
        /** @format date-time */
        StartDate?: string;
        /** @format date-time */
        EndDate?: string;
        SortOrder?: SortOrder;
        Search?: string;
        StatusId?: RoleStatus;
      },
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/suggestions`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ViewSuggestions
     * @name ViewSuggestionsUpdateSuggestions
     * @request PATCH:/suggestions
     * @secure
     */
    viewSuggestionsUpdateSuggestions: <
      TResponse = SearchBreakdownSuggestionDto,
      TError = any,
    >(
      data: Record<string, SearchBreakdownSuggestionDtoJsonPatchDocument>,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/suggestions`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ViewSuggestions
     * @name ViewSuggestionsDelete
     * @request DELETE:/suggestions
     * @secure
     */
    viewSuggestionsDelete: <TResponse = unknown, TError = any>(
      data: number[],
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/suggestions`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags PerformerSuggestions
     * @name PerformerSuggestionsGetCount
     * @request GET:/suggestions/count
     * @secure
     */
    performerSuggestionsGetCount: <TResponse = unknown, TError = any>(
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/suggestions/count`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags SearchSuggestions
     * @name SearchSuggestionsGet
     * @request GET:/suggestions/myclients/suggestions
     * @secure
     */
    searchSuggestionsGet: <TResponse = unknown, TError = any>(
      query?: {
        /** @format int32 */
        AgentId?: number;
        ArtistRef?: string;
        Search?: string;
        /** @format date-time */
        StartDate?: string;
        /** @format date-time */
        EndDate?: string;
        /** @format int32 */
        Skip?: number;
        /** @format int32 */
        Take?: number;
        View?: SuggestionsViewOptions;
      },
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/suggestions/myclients/suggestions`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags SearchSuggestions
     * @name SearchSuggestionsGetAlerts
     * @request GET:/suggestions/myclients/alerts
     * @secure
     */
    searchSuggestionsGetAlerts: <TResponse = unknown, TError = any>(
      query?: {
        SenderName?: string;
        /** @format int32 */
        Skip?: number;
        /** @format int32 */
        Take?: number;
        /** @format int32 */
        AgentId?: number;
        /** @format date-time */
        DateSentFrom?: string;
        /** @format date-time */
        DateSentTo?: string;
        SortBy?: AlertsSortingOptions;
        SortOrder?: SortOrder;
      },
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/suggestions/myclients/alerts`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags SearchSuggestions
     * @name SearchSuggestionsModifyClientAlerts
     * @request POST:/suggestions/myclients/alerts
     * @secure
     */
    searchSuggestionsModifyClientAlerts: <TResponse = unknown, TError = any>(
      data: UpdateAlertsParameters[],
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/suggestions/myclients/alerts`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags SearchSuggestions
     * @name SearchSuggestionsModifySuggestions
     * @request POST:/suggestions/breakdowns/{linkmailId}/roles/{roleId}/suggestions
     * @secure
     */
    searchSuggestionsModifySuggestions: <
      TResponse = RoleSuggestionChangesDto,
      TError = any,
    >(
      linkmailId: string,
      roleId: string,
      data: SuggestionsOperations,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/suggestions/breakdowns/${linkmailId}/roles/${roleId}/suggestions`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SearchSuggestions
     * @name SearchSuggestionsGetRoleSuggestions
     * @request GET:/suggestions/roles/{roleId}/suggestions
     * @secure
     */
    searchSuggestionsGetRoleSuggestions: <TResponse = unknown, TError = any>(
      roleId: string,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/suggestions/roles/${roleId}/suggestions`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags SearchSuggestions
     * @name SearchSuggestionsGetAgentClients
     * @request GET:/suggestions/clientsuggestions/{roleId}
     * @secure
     */
    searchSuggestionsGetAgentClients: <TResponse = unknown, TError = any>(
      roleId: string,
      query?: {
        /** @format int32 */
        Skip?: number;
        /** @format int32 */
        Take?: number;
        /** @format int32 */
        "PlayingAge.From"?: number;
        /** @format int32 */
        "PlayingAge.To"?: number;
        LocationIds?: string[];
        Genders?: number[];
        Appearances?: number[];
        HeritageAndEthnicity?: number[];
        HeritageAndEthnicityFilterMode?: FilterMode;
        PerformerName?: string;
        HeritageAndEthnicityInfo?: string;
        Agency?: number[];
        Profiles?: ProfilesOptions;
        NewSearchEnabled?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/suggestions/clientsuggestions/${roleId}`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags SearchSuggestions
     * @name SearchSuggestionsGetAgentClientsFilters
     * @request GET:/suggestions/clientsuggestions/{roleId}/filters
     * @secure
     */
    searchSuggestionsGetAgentClientsFilters: <
      TResponse = unknown,
      TError = any,
    >(
      roleId: string,
      query?: {
        /** @format int32 */
        Skip?: number;
        /** @format int32 */
        Take?: number;
        /** @format int32 */
        "PlayingAge.From"?: number;
        /** @format int32 */
        "PlayingAge.To"?: number;
        LocationIds?: string[];
        Genders?: number[];
        Appearances?: number[];
        HeritageAndEthnicity?: number[];
        HeritageAndEthnicityFilterMode?: FilterMode;
        PerformerName?: string;
        HeritageAndEthnicityInfo?: string;
        Agency?: number[];
        Profiles?: ProfilesOptions;
        NewSearchEnabled?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/suggestions/clientsuggestions/${roleId}/filters`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ViewSuggestions
     * @name ViewSuggestionsGetBreakdownInfo
     * @request GET:/suggestions/breakdowns/{linkmailId}/overview
     * @secure
     */
    viewSuggestionsGetBreakdownInfo: <TResponse = unknown, TError = any>(
      linkmailId: string,
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/suggestions/breakdowns/${linkmailId}/overview`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ViewSuggestions
     * @name ViewSuggestionsGet
     * @request GET:/suggestions/breakdowns/{linkmailId}
     * @secure
     */
    viewSuggestionsGet: <
      TResponse = SearchBreakdownSuggestionDtoCollectionDto,
      TError = any,
    >(
      linkmailId: string,
      query?: {
        UsingProfileFilters?: boolean;
        GroupBy?: LinkmailSuggestionsSearchParametersGroupingOptions;
        SortBy?: LinkmailSuggestionsSearchParametersSortingOptions;
        RepliesTo?: string[];
        Roles?: string[];
        SuggestedBy?: number[];
        Labels?: SuggestionLabels[];
        Locations?: string[];
        Search?: string;
        ArtistRefs?: string[];
        /** @format int32 */
        Skip?: number;
        /** @format int32 */
        Take?: number;
        PerformerName?: string;
        GenderInfo?: string;
        DisabilityInfo?: string;
        HeritageAndEthnicityInfo?: string;
        CastingDirectorNote?: string;
        AboutMe?: string;
        Training?: string;
        FreeText?: string;
        /** @format int32 */
        PlayingAgeMin?: number;
        /** @format int32 */
        PlayingAgeMax?: number;
        HasAudioClips?: boolean;
        HasShowReels?: boolean;
        LocationIds?: string[];
        Measurements?: Measurement[];
        PublicationCodes?: number[];
        PerformerTypes?: PerformerType[];
        /** @format int32 */
        "Credit.TypeId"?: number;
        "Credit.Role"?: string;
        "Credit.Name"?: string;
        /** @format date-time */
        "Credit.DateFrom"?: string;
        /** @format date-time */
        "Credit.DateTo"?: string;
        "Credit.Company"?: string;
        "Credit.Venue"?: string;
        "Credit.Director"?: string;
        /** @format int32 */
        CreditQty?: number;
        AccentsAndDialects?: ProfileSkillInput[];
        AccentsAndDialectsFilterMode?: FilterMode;
        VehicleLicences?: ProfileSkillInput[];
        VehicleLicencesFilterMode?: FilterMode;
        Languages?: ProfileSkillInput[];
        LanguagesFilterMode?: FilterMode;
        MusicAndDance?: ProfileSkillInput[];
        MusicAndDanceFilterMode?: FilterMode;
        OtherSkills?: ProfileSkillInput[];
        OtherSkillsFilterMode?: FilterMode;
        Performances?: ProfileSkillInput[];
        PerformancesFilterMode?: FilterMode;
        Sports?: ProfileSkillInput[];
        SportsFilterMode?: FilterMode;
        Presenting?: ProfileSkillInput[];
        PresentingFilterMode?: FilterMode;
        VoiceOver?: ProfileSkillInput[];
        VoiceOverFilterMode?: FilterMode;
        Gender?: number[];
        Disabilities?: number[];
        EyeColours?: number[];
        FacialHairs?: number[];
        HairColours?: number[];
        HairLength?: number[];
        Appearances?: number[];
        VoiceStyles?: number[];
        VoiceStyleFilterMode?: FilterMode;
        Nationalities?: number[];
        BeltNotes?: number[];
        HeritageAndEthnicity?: number[];
        HeritageAndEthnicityFilterMode?: FilterMode;
        Agents?: string[];
        AgentRefs?: number[];
        IsSelfRepresented?: boolean;
        IsLookingForRepresentation?: boolean;
        DramaSchools?: string[];
        OrderBy?: SearchProfileOrderBy;
        SearchExecuted?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/suggestions/breakdowns/${linkmailId}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ViewSuggestions
     * @name ViewSuggestionsUpdateSuggestion
     * @request PATCH:/suggestions/{suggestionId}
     * @secure
     */
    viewSuggestionsUpdateSuggestion: <TResponse = unknown, TError = any>(
      suggestionId: number,
      data: Operation[],
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/suggestions/${suggestionId}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ViewSuggestions
     * @name ViewSuggestionsGetBreakdownFilters
     * @request GET:/suggestions/breakdowns/{linkmailId}/filters
     * @secure
     */
    viewSuggestionsGetBreakdownFilters: <
      TResponse = BreakdownFiltersDto,
      TError = any,
    >(
      linkmailId: string,
      query?: {
        RepliesTo?: string[];
        Roles?: string[];
        SuggestedBy?: number[];
        Labels?: SuggestionLabels[];
        Locations?: string[];
        Search?: string;
        ArtistRefs?: string[];
        /** @format int32 */
        Skip?: number;
        /** @format int32 */
        Take?: number;
        PerformerName?: string;
        GenderInfo?: string;
        DisabilityInfo?: string;
        HeritageAndEthnicityInfo?: string;
        CastingDirectorNote?: string;
        AboutMe?: string;
        Training?: string;
        FreeText?: string;
        /** @format int32 */
        PlayingAgeMin?: number;
        /** @format int32 */
        PlayingAgeMax?: number;
        HasAudioClips?: boolean;
        HasShowReels?: boolean;
        LocationIds?: string[];
        Measurements?: Measurement[];
        PublicationCodes?: number[];
        PerformerTypes?: PerformerType[];
        /** @format int32 */
        "Credit.TypeId"?: number;
        "Credit.Role"?: string;
        "Credit.Name"?: string;
        /** @format date-time */
        "Credit.DateFrom"?: string;
        /** @format date-time */
        "Credit.DateTo"?: string;
        "Credit.Company"?: string;
        "Credit.Venue"?: string;
        "Credit.Director"?: string;
        /** @format int32 */
        CreditQty?: number;
        AccentsAndDialects?: ProfileSkillInput[];
        AccentsAndDialectsFilterMode?: FilterMode;
        VehicleLicences?: ProfileSkillInput[];
        VehicleLicencesFilterMode?: FilterMode;
        Languages?: ProfileSkillInput[];
        LanguagesFilterMode?: FilterMode;
        MusicAndDance?: ProfileSkillInput[];
        MusicAndDanceFilterMode?: FilterMode;
        OtherSkills?: ProfileSkillInput[];
        OtherSkillsFilterMode?: FilterMode;
        Performances?: ProfileSkillInput[];
        PerformancesFilterMode?: FilterMode;
        Sports?: ProfileSkillInput[];
        SportsFilterMode?: FilterMode;
        Presenting?: ProfileSkillInput[];
        PresentingFilterMode?: FilterMode;
        VoiceOver?: ProfileSkillInput[];
        VoiceOverFilterMode?: FilterMode;
        Gender?: number[];
        Disabilities?: number[];
        EyeColours?: number[];
        FacialHairs?: number[];
        HairColours?: number[];
        HairLength?: number[];
        Appearances?: number[];
        VoiceStyles?: number[];
        VoiceStyleFilterMode?: FilterMode;
        Nationalities?: number[];
        BeltNotes?: number[];
        HeritageAndEthnicity?: number[];
        HeritageAndEthnicityFilterMode?: FilterMode;
        Agents?: string[];
        AgentRefs?: number[];
        IsSelfRepresented?: boolean;
        IsLookingForRepresentation?: boolean;
        DramaSchools?: string[];
        OrderBy?: SearchProfileOrderBy;
        SearchExecuted?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/suggestions/breakdowns/${linkmailId}/filters`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
  whoami = {
    /**
     * No description
     *
     * @tags Whoami
     * @name WhoamiGet
     * @request GET:/Whoami
     * @secure
     */
    whoamiGet: <TResponse = WhoamiDto, TError = any>(
      params: RequestParams = {},
    ) =>
      this.request<TResponse, TError>({
        path: `/Whoami`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
}
